import { httpPost } from "../../services/api";
import { BinLookupData } from "../types/binLookup";

export type NativeReceiptData = {
  receipt: string;
  receiptBillingData: Partial<Record<string, string>>;
};

export const sdkBinLookupByReceipt = async ({
  publicApiKey,
  nativeReceiptData,
  methodId,
  flowId,
}: {
  publicApiKey: string;
  nativeReceiptData: NativeReceiptData;
  methodId: string;
  flowId?: string;
}) => {
  const { data } = await httpPost<{ data: BinLookupData }>(
    "applepay_bin_lookup/",
    {
      ...nativeReceiptData,
      method_id: methodId,
      ...(flowId && { flow_id: flowId }),
    },
    false,
    {
      "x-public-key": publicApiKey,
    }
  );

  return {
    firstSixDigits: data.first_six_digits,
    brand: data.brand,
    cardType: data.card_type,
    issuer: data.issuer,
    issuerCountry: data.issuer_country,
    issuerCountryCode: data.issuer_country_code,
    product: data.product,
  };
};
